// src/countries.ts
var countries = [
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "ET",
    insuranceTax: null,
    name: "Ethiopia",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "FI",
    insuranceTax: 0.255,
    name: "Finland",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Northern Europe",
    subregionCode: "154"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "FJ",
    insuranceTax: null,
    name: "Fiji",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Melanesia",
    subregionCode: "054"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "FK",
    insuranceTax: null,
    name: "Falkland Islands (Malvinas)",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "FM",
    insuranceTax: null,
    name: "Micronesia, Federated States of",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Micronesia",
    subregionCode: "057"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "FO",
    insuranceTax: null,
    name: "Faroe Islands",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Northern Europe",
    subregionCode: "154"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "FR",
    insuranceTax: 0.09,
    name: "France",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0.2,
    subregion: "Western Europe",
    subregionCode: "155"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GA",
    insuranceTax: null,
    name: "Gabon",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GB",
    insuranceTax: 0.2,
    name: "United Kingdom",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Northern Europe",
    subregionCode: "154"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GD",
    insuranceTax: null,
    name: "Grenada",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GE",
    insuranceTax: null,
    name: "Georgia",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GF",
    insuranceTax: null,
    name: "French Guiana",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GG",
    insuranceTax: null,
    name: "Guernsey",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Northern Europe",
    subregionCode: "154"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GH",
    insuranceTax: null,
    name: "Ghana",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GI",
    insuranceTax: null,
    name: "Gibraltar",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GL",
    insuranceTax: null,
    name: "Greenland",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Northern America",
    subregionCode: "021"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GM",
    insuranceTax: null,
    name: "Gambia",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GN",
    insuranceTax: null,
    name: "Guinea",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GP",
    insuranceTax: null,
    name: "Guadeloupe",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GQ",
    insuranceTax: null,
    name: "Equatorial Guinea",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "GR",
    insuranceTax: 0.15,
    name: "Greece",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GS",
    insuranceTax: null,
    name: "South Georgia and the South Sandwich Islands",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GT",
    insuranceTax: null,
    name: "Guatemala",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GU",
    insuranceTax: null,
    name: "Guam",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Micronesia",
    subregionCode: "057"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GW",
    insuranceTax: null,
    name: "Guinea-Bissau",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "GY",
    insuranceTax: null,
    name: "Guyana",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "HK",
    insuranceTax: null,
    name: "Hong Kong",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Eastern Asia",
    subregionCode: "030"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "HM",
    insuranceTax: null,
    name: "Heard Island and McDonald Islands",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Australia and New Zealand",
    subregionCode: "053"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "HN",
    insuranceTax: null,
    name: "Honduras",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "HR",
    insuranceTax: 0,
    name: "Croatia",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "HT",
    insuranceTax: null,
    name: "Haiti",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "HU",
    insuranceTax: 0.1,
    name: "Hungary",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Eastern Europe",
    subregionCode: "151"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "ID",
    insuranceTax: null,
    name: "Indonesia",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "South-eastern Asia",
    subregionCode: "035"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "IE",
    insuranceTax: 0.04,
    name: "Ireland",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Northern Europe",
    subregionCode: "154"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "IL",
    insuranceTax: null,
    name: "Israel",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "IM",
    insuranceTax: null,
    name: "Isle of Man",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Northern Europe",
    subregionCode: "154"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "IN",
    insuranceTax: null,
    name: "India",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Southern Asia",
    subregionCode: "034"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "IO",
    insuranceTax: null,
    name: "British Indian Ocean Territory",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "IQ",
    insuranceTax: null,
    name: "Iraq",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "IR",
    insuranceTax: null,
    name: "Iran",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Southern Asia",
    subregionCode: "034"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "IS",
    insuranceTax: 45e-6,
    name: "Iceland",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Northern Europe",
    subregionCode: "154"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "LA",
    insuranceTax: null,
    name: "Lao People's Democratic Republic",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "South-eastern Asia",
    subregionCode: "035"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "LB",
    insuranceTax: null,
    name: "Lebanon",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "LC",
    insuranceTax: null,
    name: "Saint Lucia",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "LI",
    insuranceTax: 0.05,
    name: "Liechtenstein",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Western Europe",
    subregionCode: "155"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "LK",
    insuranceTax: null,
    name: "Sri Lanka",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Southern Asia",
    subregionCode: "034"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "LR",
    insuranceTax: null,
    name: "Liberia",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "LS",
    insuranceTax: null,
    name: "Lesotho",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "YT",
    insuranceTax: null,
    name: "Mayotte",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BI",
    insuranceTax: null,
    name: "Burundi",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BJ",
    insuranceTax: null,
    name: "Benin",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BL",
    insuranceTax: null,
    name: "Saint Barth\xE9lemy",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BM",
    insuranceTax: null,
    name: "Bermuda",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Northern America",
    subregionCode: "021"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BN",
    insuranceTax: null,
    name: "Brunei Darussalam",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "South-eastern Asia",
    subregionCode: "035"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BO",
    insuranceTax: null,
    name: "Bolivia",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BQ",
    insuranceTax: null,
    name: "Bonaire, Sint Eustatius and Saba",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BR",
    insuranceTax: null,
    name: "Brazil",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BS",
    insuranceTax: null,
    name: "Bahamas",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BT",
    insuranceTax: null,
    name: "Bhutan",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Southern Asia",
    subregionCode: "034"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BV",
    insuranceTax: null,
    name: "Bouvet Island",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BW",
    insuranceTax: null,
    name: "Botswana",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BY",
    insuranceTax: null,
    name: "Belarus",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Eastern Europe",
    subregionCode: "151"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BZ",
    insuranceTax: null,
    name: "Belize",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "NORTH_AMERICA",
    id: "CA",
    insuranceTax: null,
    name: "Canada",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Northern America",
    subregionCode: "021"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "CC",
    insuranceTax: null,
    name: "Cocos (Keeling) Islands",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Australia and New Zealand",
    subregionCode: "053"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "CD",
    insuranceTax: null,
    name: "Congo, the Democratic Republic of the",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "CF",
    insuranceTax: null,
    name: "Central African Republic",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "CG",
    insuranceTax: null,
    name: "Congo",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "CH",
    insuranceTax: 0.05,
    name: "Switzerland",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Western Europe",
    subregionCode: "155"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "CI",
    insuranceTax: null,
    name: "Ivory Coast",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "CK",
    insuranceTax: null,
    name: "Cook Islands",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Polynesia",
    subregionCode: "061"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "CL",
    insuranceTax: null,
    name: "Chile",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "CM",
    insuranceTax: null,
    name: "Cameroon",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "CN",
    insuranceTax: 0,
    name: "China",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Eastern Asia",
    subregionCode: "030"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "CO",
    insuranceTax: null,
    name: "Colombia",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "CR",
    insuranceTax: null,
    name: "Costa Rica",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "CU",
    insuranceTax: null,
    name: "Cuba",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "CV",
    insuranceTax: null,
    name: "Cape Verde",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "CW",
    insuranceTax: null,
    name: "Cura\xE7ao",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "CX",
    insuranceTax: null,
    name: "Christmas Island",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Australia and New Zealand",
    subregionCode: "053"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "CY",
    insuranceTax: 0,
    name: "Cyprus",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "CZ",
    insuranceTax: 0,
    name: "Czech Republic",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Eastern Europe",
    subregionCode: "151"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "DE",
    insuranceTax: 0.19,
    name: "Germany",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Western Europe",
    subregionCode: "155"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "DJ",
    insuranceTax: null,
    name: "Djibouti",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "DK",
    insuranceTax: 0.011,
    name: "Denmark",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Northern Europe",
    subregionCode: "154"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "DM",
    insuranceTax: null,
    name: "Dominica",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "DO",
    insuranceTax: null,
    name: "Dominican Republic",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "DZ",
    insuranceTax: null,
    name: "Algeria",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Northern Africa",
    subregionCode: "015"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "EC",
    insuranceTax: null,
    name: "Ecuador",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "EE",
    insuranceTax: null,
    name: "Estonia",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Northern Europe",
    subregionCode: "154"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "EG",
    insuranceTax: null,
    name: "Egypt",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Northern Africa",
    subregionCode: "015"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "EH",
    insuranceTax: null,
    name: "Western Sahara",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Northern Africa",
    subregionCode: "015"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "ER",
    insuranceTax: null,
    name: "Eritrea",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "ES",
    insuranceTax: 0.08,
    name: "Spain",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "LT",
    insuranceTax: 0.1,
    name: "Lithuania",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Northern Europe",
    subregionCode: "154"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "LU",
    insuranceTax: 0.04,
    name: "Luxembourg",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Western Europe",
    subregionCode: "155"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "VG",
    insuranceTax: null,
    name: "Virgin Islands, British",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "WS",
    insuranceTax: null,
    name: "Samoa",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Polynesia",
    subregionCode: "061"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "AD",
    insuranceTax: null,
    name: "Andorra",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "AE",
    insuranceTax: null,
    name: "United Arab Emirates",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "AF",
    insuranceTax: null,
    name: "Afghanistan",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Southern Asia",
    subregionCode: "034"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "AG",
    insuranceTax: null,
    name: "Antigua and Barbuda",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "AI",
    insuranceTax: null,
    name: "Anguilla",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "AL",
    insuranceTax: null,
    name: "Albania",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "AM",
    insuranceTax: null,
    name: "Armenia",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "AO",
    insuranceTax: null,
    name: "Angola",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "AQ",
    insuranceTax: null,
    name: "Antarctica",
    region: "Antarctica",
    regionCode: "010",
    serviceTax: 0,
    subregion: "Antarctica",
    subregionCode: "010"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "AR",
    insuranceTax: null,
    name: "Argentina",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "AS",
    insuranceTax: null,
    name: "American Samoa",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Polynesia",
    subregionCode: "061"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "AT",
    insuranceTax: 0.11,
    name: "Austria",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Western Europe",
    subregionCode: "155"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "AU",
    insuranceTax: null,
    name: "Australia",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Australia and New Zealand",
    subregionCode: "053"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "AW",
    insuranceTax: null,
    name: "Aruba",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "AX",
    insuranceTax: null,
    name: "\xC5land Islands",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Northern Europe",
    subregionCode: "154"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "AZ",
    insuranceTax: null,
    name: "Azerbaijan",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BA",
    insuranceTax: null,
    name: "Bosnia and Herzegovina",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BB",
    insuranceTax: null,
    name: "Barbados",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BD",
    insuranceTax: null,
    name: "Bangladesh",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Southern Asia",
    subregionCode: "034"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "BE",
    insuranceTax: 0.096,
    name: "Belgium",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Western Europe",
    subregionCode: "155"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BF",
    insuranceTax: null,
    name: "Burkina Faso",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "BG",
    insuranceTax: 0.02,
    name: "Bulgaria",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Eastern Europe",
    subregionCode: "151"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "BH",
    insuranceTax: null,
    name: "Bahrain",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "IT",
    insuranceTax: 0.0478,
    name: "Italy",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "JE",
    insuranceTax: null,
    name: "Jersey",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Northern Europe",
    subregionCode: "154"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "JM",
    insuranceTax: null,
    name: "Jamaica",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "JO",
    insuranceTax: null,
    name: "Jordan",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "JP",
    insuranceTax: null,
    name: "Japan",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Eastern Asia",
    subregionCode: "030"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "KE",
    insuranceTax: null,
    name: "Kenya",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "KG",
    insuranceTax: null,
    name: "Kyrgyzstan",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Central Asia",
    subregionCode: "143"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "KH",
    insuranceTax: null,
    name: "Cambodia",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "South-eastern Asia",
    subregionCode: "035"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "KI",
    insuranceTax: null,
    name: "Kiribati",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Micronesia",
    subregionCode: "057"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "KM",
    insuranceTax: null,
    name: "Comoros",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "KN",
    insuranceTax: null,
    name: "Saint Kitts and Nevis",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "KP",
    insuranceTax: null,
    name: "Democratic People's Republic of Korea",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Eastern Asia",
    subregionCode: "030"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "KR",
    insuranceTax: null,
    name: "Republic of Korea",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Eastern Asia",
    subregionCode: "030"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "KW",
    insuranceTax: null,
    name: "Kuwait",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "KY",
    insuranceTax: null,
    name: "Cayman Islands",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "KZ",
    insuranceTax: null,
    name: "Kazakhstan",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Central Asia",
    subregionCode: "143"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "PM",
    insuranceTax: null,
    name: "Saint Pierre and Miquelon",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Northern America",
    subregionCode: "021"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "PN",
    insuranceTax: null,
    name: "Pitcairn",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Polynesia",
    subregionCode: "061"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "PR",
    insuranceTax: null,
    name: "Puerto Rico",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "PS",
    insuranceTax: null,
    name: "Palestine, State of",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "PT",
    insuranceTax: 0.09,
    name: "Portugal",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "PW",
    insuranceTax: null,
    name: "Palau",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Micronesia",
    subregionCode: "057"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "PY",
    insuranceTax: null,
    name: "Paraguay",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "QA",
    insuranceTax: null,
    name: "Qatar",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "VC",
    insuranceTax: null,
    name: "Saint Vincent and the Grenadines",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "VE",
    insuranceTax: null,
    name: "Venezuela",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "LV",
    insuranceTax: null,
    name: "Latvia",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Northern Europe",
    subregionCode: "154"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "LY",
    insuranceTax: null,
    name: "Libya",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Northern Africa",
    subregionCode: "015"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MA",
    insuranceTax: null,
    name: "Morocco",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Northern Africa",
    subregionCode: "015"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "MC",
    insuranceTax: null,
    name: "Monaco",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Western Europe",
    subregionCode: "155"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MD",
    insuranceTax: null,
    name: "Moldova",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Eastern Europe",
    subregionCode: "151"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "ME",
    insuranceTax: null,
    name: "Montenegro",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MF",
    insuranceTax: null,
    name: "Saint Martin (French part)",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MG",
    insuranceTax: null,
    name: "Madagascar",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MH",
    insuranceTax: null,
    name: "Marshall Islands",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Micronesia",
    subregionCode: "057"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MK",
    insuranceTax: null,
    name: "Macedonia, the Former Yugoslav Republic of",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "ML",
    insuranceTax: null,
    name: "Mali",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MM",
    insuranceTax: null,
    name: "Myanmar",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "South-eastern Asia",
    subregionCode: "035"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MN",
    insuranceTax: null,
    name: "Mongolia",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Eastern Asia",
    subregionCode: "030"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MO",
    insuranceTax: null,
    name: "Macao",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Eastern Asia",
    subregionCode: "030"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MP",
    insuranceTax: null,
    name: "Northern Mariana Islands",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Micronesia",
    subregionCode: "057"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MQ",
    insuranceTax: null,
    name: "Martinique",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MR",
    insuranceTax: null,
    name: "Mauritania",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MS",
    insuranceTax: null,
    name: "Montserrat",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "MT",
    insuranceTax: 0.11,
    name: "Malta",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MU",
    insuranceTax: null,
    name: "Mauritius",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MV",
    insuranceTax: null,
    name: "Maldives",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Southern Asia",
    subregionCode: "034"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MW",
    insuranceTax: null,
    name: "Malawi",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MX",
    insuranceTax: null,
    name: "Mexico",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MY",
    insuranceTax: null,
    name: "Malaysia",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "South-eastern Asia",
    subregionCode: "035"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "MZ",
    insuranceTax: null,
    name: "Mozambique",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "NA",
    insuranceTax: null,
    name: "Namibia",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "NC",
    insuranceTax: null,
    name: "New Caledonia",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Melanesia",
    subregionCode: "054"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "NE",
    insuranceTax: null,
    name: "Niger",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "NF",
    insuranceTax: null,
    name: "Norfolk Island",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Australia and New Zealand",
    subregionCode: "053"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "NG",
    insuranceTax: null,
    name: "Nigeria",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "NI",
    insuranceTax: null,
    name: "Nicaragua",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "NL",
    insuranceTax: 0.21,
    name: "Netherlands",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Western Europe",
    subregionCode: "155"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "NO",
    insuranceTax: null,
    name: "Norway",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Northern Europe",
    subregionCode: "154"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "NP",
    insuranceTax: null,
    name: "Nepal",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Southern Asia",
    subregionCode: "034"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "NR",
    insuranceTax: null,
    name: "Nauru",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Micronesia",
    subregionCode: "057"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "NU",
    insuranceTax: null,
    name: "Niue",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Polynesia",
    subregionCode: "061"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "NZ",
    insuranceTax: null,
    name: "New Zealand",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Australia and New Zealand",
    subregionCode: "053"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "OM",
    insuranceTax: null,
    name: "Oman",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "PA",
    insuranceTax: null,
    name: "Panama",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "PE",
    insuranceTax: null,
    name: "Peru",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "PF",
    insuranceTax: null,
    name: "French Polynesia",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Polynesia",
    subregionCode: "061"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "PG",
    insuranceTax: null,
    name: "Papua New Guinea",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Melanesia",
    subregionCode: "054"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "PH",
    insuranceTax: null,
    name: "Philippines",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "South-eastern Asia",
    subregionCode: "035"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "PK",
    insuranceTax: null,
    name: "Pakistan",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Southern Asia",
    subregionCode: "034"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "PL",
    insuranceTax: 0,
    name: "Poland",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Eastern Europe",
    subregionCode: "151"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "RE",
    insuranceTax: null,
    name: "R\xE9union",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "RO",
    insuranceTax: 0.01,
    name: "Romania",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Eastern Europe",
    subregionCode: "151"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "RS",
    insuranceTax: null,
    name: "Serbia",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "RU",
    insuranceTax: null,
    name: "Russia",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Eastern Europe",
    subregionCode: "151"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "RW",
    insuranceTax: null,
    name: "Rwanda",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "SA",
    insuranceTax: null,
    name: "Saudi Arabia",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "SB",
    insuranceTax: null,
    name: "Solomon Islands",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Melanesia",
    subregionCode: "054"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "SC",
    insuranceTax: null,
    name: "Seychelles",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "SD",
    insuranceTax: null,
    name: "Sudan",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Northern Africa",
    subregionCode: "015"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "SE",
    insuranceTax: null,
    name: "Sweden",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Northern Europe",
    subregionCode: "154"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "SG",
    insuranceTax: null,
    name: "Singapore",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "South-eastern Asia",
    subregionCode: "035"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "SH",
    insuranceTax: null,
    name: "Saint Helena, Ascension and Tristan da Cunha",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "SI",
    insuranceTax: 0.085,
    name: "Slovenia",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "SJ",
    insuranceTax: null,
    name: "Svalbard and Jan Mayen",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Northern Europe",
    subregionCode: "154"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "SK",
    insuranceTax: 0.1,
    name: "Slovakia",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Eastern Europe",
    subregionCode: "151"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "SL",
    insuranceTax: null,
    name: "Sierra Leone",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "SM",
    insuranceTax: null,
    name: "San Marino",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "SN",
    insuranceTax: null,
    name: "Senegal",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "SO",
    insuranceTax: null,
    name: "Somalia",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "SR",
    insuranceTax: null,
    name: "Surinam",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "SS",
    insuranceTax: null,
    name: "South Sudan",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "ST",
    insuranceTax: null,
    name: "Sao Tome and Principe",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "SV",
    insuranceTax: null,
    name: "El Salvador",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "SX",
    insuranceTax: null,
    name: "Sint Maarten (Dutch part)",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "SY",
    insuranceTax: null,
    name: "Syrian Arab Republic",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "SZ",
    insuranceTax: null,
    name: "Swaziland",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "TC",
    insuranceTax: null,
    name: "Turks and Caicos Islands",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "TD",
    insuranceTax: null,
    name: "Chad",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "TF",
    insuranceTax: null,
    name: "French Southern Territories",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "TG",
    insuranceTax: null,
    name: "Togo",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "TH",
    insuranceTax: null,
    name: "Thailand",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "South-eastern Asia",
    subregionCode: "035"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "TJ",
    insuranceTax: null,
    name: "Tajikistan",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Central Asia",
    subregionCode: "143"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "TK",
    insuranceTax: null,
    name: "Tokelau",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Polynesia",
    subregionCode: "061"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "TL",
    insuranceTax: null,
    name: "Timor-Leste",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "South-eastern Asia",
    subregionCode: "035"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "TM",
    insuranceTax: null,
    name: "Turkmenistan",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Central Asia",
    subregionCode: "143"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "TN",
    insuranceTax: null,
    name: "Tunisia",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Northern Africa",
    subregionCode: "015"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "TO",
    insuranceTax: null,
    name: "Tonga",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Polynesia",
    subregionCode: "061"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "TR",
    insuranceTax: null,
    name: "Turkey",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "TT",
    insuranceTax: null,
    name: "Trinidad and Tobago",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "TV",
    insuranceTax: null,
    name: "Tuvalu",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Polynesia",
    subregionCode: "061"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "TW",
    insuranceTax: null,
    name: "Taiwan",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Eastern Asia",
    subregionCode: "030"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "TZ",
    insuranceTax: null,
    name: "Tanzania",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "UA",
    insuranceTax: null,
    name: "Ukraine",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Eastern Europe",
    subregionCode: "151"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "UG",
    insuranceTax: null,
    name: "Uganda",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "UM",
    insuranceTax: null,
    name: "United States Minor Outlying Islands",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Micronesia",
    subregionCode: "057"
  },
  {
    additionalTax: 0,
    geographicalArea: "NORTH_AMERICA",
    id: "US",
    insuranceTax: 0.03,
    name: "United States",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Northern America",
    subregionCode: "021"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "UY",
    insuranceTax: null,
    name: "Uruguay",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "UZ",
    insuranceTax: null,
    name: "Uzbekistan",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Central Asia",
    subregionCode: "143"
  },
  {
    additionalTax: 0,
    geographicalArea: "EUROPE",
    id: "VA",
    insuranceTax: null,
    name: "Holy See (Vatican City State)",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "VI",
    insuranceTax: null,
    name: "Virgin Islands, U.S.",
    region: "Americas",
    regionCode: "019",
    serviceTax: 0,
    subregion: "Latin America and the Caribbean",
    subregionCode: "419"
  },
  {
    additionalTax: 0.1,
    geographicalArea: "WORLD",
    id: "VN",
    insuranceTax: 0.1,
    name: "Vietnam",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "South-eastern Asia",
    subregionCode: "035"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "VU",
    insuranceTax: null,
    name: "Vanuatu",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Melanesia",
    subregionCode: "054"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "WF",
    insuranceTax: null,
    name: "Wallis and Futuna",
    region: "Oceania",
    regionCode: "009",
    serviceTax: 0,
    subregion: "Polynesia",
    subregionCode: "061"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "XK",
    insuranceTax: null,
    name: "Kosovo",
    region: "Europe",
    regionCode: "150",
    serviceTax: 0,
    subregion: "Southern Europe",
    subregionCode: "039"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "YE",
    insuranceTax: null,
    name: "Yemen",
    region: "Asia",
    regionCode: "142",
    serviceTax: 0,
    subregion: "Western Asia",
    subregionCode: "145"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "ZA",
    insuranceTax: null,
    name: "South Africa",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "ZM",
    insuranceTax: null,
    name: "Zambia",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  },
  {
    additionalTax: 0,
    geographicalArea: "WORLD",
    id: "ZW",
    insuranceTax: null,
    name: "Zimbabwe",
    region: "Africa",
    regionCode: "002",
    serviceTax: 0,
    subregion: "Sub-Saharan Africa",
    subregionCode: "202"
  }
];
export {
  countries
};
//# sourceMappingURL=index.js.map